import {createFeatureSelector, createSelector} from '@ngrx/store';
import { InfoKategorie } from '../../../../clients/veranstaltungen';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {ModuleState, PageState} from './veranstaltungen-info-kategorien.reducer';

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('VeranstaltungenInfoKategorienPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getAktuelleVeranstaltungId = createSelector(getPageState, (state: PageState) => state.aktuelleVeranstaltungsId);
export const getVeranstaltungInfoKategorien = createSelector(getPageState, (state: PageState) => {
    if (state.infoKategorien === null || state.infoKategorien === undefined) {
        return [];
    }

    const liste = [...state.infoKategorien];

    return liste.map((item: InfoKategorie) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.kategorie_id,
        itemTitle: item.titel,
        item: item
    });
});

export const getVeranstaltungInfoKategorienList = createSelector(getPageState, (state: PageState) => state.infoKategorien);

